import * as types from '../../action-types';

export default (fieldName, fieldValue, paymentMethod) => ({
  type: types.UPDATE_BILLING_ADDRESS_BY_PAYMENT_METHOD,
  fieldName,
  fieldValue,
  paymentMethod,
});
